import _jsx from '@babel/runtime/helpers/jsx';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import classnames from 'classnames';
import { componentEnhance } from '@vpp-frontend-components/component-enhance';
import { arrayIncludes } from '@vpp-frontend-components/common';
import List$1 from '@andes/list';
const LIST_TYPES = {
  ordered: {
    styles: ['NUMBER'],
    name: 'ORDERED'
  },
  unordered: {
    styles: ['NONE', 'CIRCLE'],
    name: 'UNORDERED'
  },
  row: {
    styles: ['ROW'],
    name: 'ROW'
  }
};
const transformToListType = style => {
  if (arrayIncludes(LIST_TYPES.row.styles, style)) {
    return LIST_TYPES.row.name;
  }
  if (arrayIncludes(LIST_TYPES.ordered.styles, style)) {
    return LIST_TYPES.ordered.name;
  }
  return LIST_TYPES.unordered.name;
};
const namespace$2 = 'ui-vpp-simple-list';

/**
 * OrderedList component
 * @typedef {import('../../index').OrderedList}
 */
const OrderedList = _ref => {
  let {
    className = '',
    children
  } = _ref;
  return /*#__PURE__*/_jsx("ol", {
    className: className
  }, void 0, children);
};

/**
 * UnorderedList component
 * @typedef {import('../../index').UnorderedList}
 */
const UnorderedList = _ref2 => {
  let {
    className = '',
    children
  } = _ref2;
  return /*#__PURE__*/_jsx("ul", {
    className: className
  }, void 0, children);
};

/**
 * SimpleList component
 * @typedef {import('../../index').SimpleList}
 */
const SimpleList = _ref3 => {
  let {
    className = '',
    listType = 'UNORDERED',
    listStyle = null,
    list
  } = _ref3;
  const List = listType === LIST_TYPES.ordered.name ? OrderedList : UnorderedList;
  return /*#__PURE__*/_jsx(List, {
    className: classnames(namespace$2, className, {
      [`${namespace$2}--${listStyle}`]: listStyle && listStyle !== 'NONE'
    })
  }, void 0, list.map((li, i) => /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  _jsx("li", {}, i, li.title && /*#__PURE__*/React.createElement(StyledLabel, _extends({
    as: "span"
  }, li.title, {
    text: componentEnhance.jsx(li.title.text, li.title.values)
  })))));
};
const {
  ListItem
} = List$1;
const namespace$1 = 'ui-vpp-row-list';

/**
 * RowList component
 * @typedef {import('../../index').RowList}
 */
const RowList = _ref => {
  let {
    className = '',
    list,
    is_selectable = false
  } = _ref;
  return /*#__PURE__*/_jsx(List$1, {
    className: classnames(namespace$1, className),
    selectable: is_selectable
  }, void 0, list.map(li => /*#__PURE__*/_jsx(ListItem, {
    title: (li === null || li === void 0 ? void 0 : li.title) && (li === null || li === void 0 ? void 0 : li.title.text),
    description: (li === null || li === void 0 ? void 0 : li.description) && (li === null || li === void 0 ? void 0 : li.description.text),
    rightContent: (li === null || li === void 0 ? void 0 : li.detail) && li.detail.text
  })));
};
const _excluded = ["title", "style"];
const namespace = 'ui-vpp-generic-list';

/**
 * List component
 * @typedef {import('../../index').List}
 */
const List = _ref => {
  let {
      title = null,
      style = 'NONE'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const listType = transformToListType(style);
  return /*#__PURE__*/_jsx("div", {
    className: namespace
  }, void 0, title && /*#__PURE__*/React.createElement(StyledLabel, _extends({
    className: `${namespace}__title`,
    as: "h3",
    text: title
  }, title)), listType === LIST_TYPES.row.name ? /*#__PURE__*/React.createElement(RowList, rest) : /*#__PURE__*/React.createElement(SimpleList, _extends({
    listStyle: style,
    listType: listType
  }, rest)));
};
export { LIST_TYPES, List, RowList, SimpleList, transformToListType };
